import gql from 'graphql-tag';

export const RetailerListQuery = gql`
	query RetailerListQuery(
		$first: Int,
		$cursor: String,
		$orderBy: RetailerOrderBy,
		$orderDesc: Boolean,
		$filter: RetailerFilterInput
	) {
		entities: retailers(first: $first, after: $cursor, orderBy: $orderBy, orderDesc: $orderDesc, filter: $filter) {
			edges {
				node {
					id
					localId
					name
					type
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}

	}
`;


